import React, { useState, useRef } from 'react';
import { SketchPicker, ColorResult } from 'react-color';
import { ClickAwayListener, Box } from '@mui/material';
import Icon from 'icons/Icon';

type Props = {
  textColor: string;
  textBackgroundColor: string;
  handleChangeCompletebckGrnd: (color: string) => void;
  handleChangeComplete: (color: string) => void;
};

const TextStyle: React.FC<Props> = ({
  textColor,
  textBackgroundColor,
  handleChangeCompletebckGrnd,
  handleChangeComplete,
}) => {
  const [show, setShow] = useState(false);
  const colorPickerRef = useRef<HTMLDivElement | null>(null);
  const buttonRef = useRef<HTMLButtonElement | null>(null);

  const handleClick = (e: React.MouseEvent<any>) => {
    e.preventDefault();
    e.stopPropagation();
    setShow((prevShow) => !prevShow);
  };

  const handleChangeCompletebckGrndWrapper = (color: ColorResult) => {
    handleChangeCompletebckGrnd(color.hex);
  };

  const handleChangeCompleteWrapper = (color: ColorResult) => {
    handleChangeComplete(color.hex);
  };

  const handleClickAway = () => {
    setShow(false);
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <>
        <Box
          onMouseDown={(event) => {
            event.preventDefault();
            handleClick(event);
          }}
          ref={buttonRef}
          sx={{
            cursor: 'pointer',
            padding: 1,
            height: 32,
          }}
        >
          <Icon color={show ? 'primary' : '#fff'} iconName={'font'} />
        </Box>
        {show && (
          <div
            ref={colorPickerRef}
            style={{
              position: 'absolute',
              top: buttonRef.current ? buttonRef.current.offsetTop + 32 : 0,
              left: buttonRef.current ? buttonRef.current.offsetLeft : 0,
              display: 'flex',
              gap: '20px',
              border: '1px solid #ddd',
              padding: '10px',
              backgroundColor: '#fff',
              borderRadius: '4px',
              zIndex: 1,
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <p style={{ margin: '0 0 10px 0' }}>Background color</p>
              <SketchPicker
                color={textBackgroundColor}
                onChangeComplete={handleChangeCompletebckGrndWrapper}
              />
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <p style={{ margin: '0 0 10px 0' }}>Text color</p>
              <SketchPicker
                color={textColor}
                onChangeComplete={handleChangeCompleteWrapper}
              />
            </div>
          </div>
        )}
      </>
    </ClickAwayListener>
  );
};

export default TextStyle;
